import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { marker } from "@jsverse/transloco-keys-manager/marker";
import { pickBy } from "lodash";
import { Observable } from "rxjs";
import { UserNotify } from "src/app/support/notify-decorator";
import { PageRequest } from "src/app/support/page-request";
import { PaginatedResult } from "src/app/support/paginated-result";
import { environment } from "src/environments/environment";

@Injectable()
export class VilmaBackend {
  private readonly http = inject(HttpClient);

  @UserNotify({
    successMessage: marker("Tenant creato"),
    errorMessage: marker("Impossibile creare il tenant")
  })
  create(tenant: string, payload: any): Observable<any> {
    return this.http.post<any>(
      `${environment.snoots.vilma.host}/api/tenants/${tenant}`,
      payload,
      {
        headers: new HttpHeaders({
          "Access-Control-Allow-Origin": "*"
        })
      }
    );
  }

  @UserNotify({
    successMessage: marker("Membro creato"),
    errorMessage: marker("Impossibile creare il membro")
  })
  createMembers(
    tenant: string,
    payload: {
      username: string;
      password: string;
      firstName: string;
      lastName: string;
      email?: string;
    }
  ): Observable<any> {
    return this.http.post<any>(
      `${environment.snoots.vilma.host}/api/tenants/${tenant}/members`,
      payload
    );
  }

  @UserNotify({
    successMessage: marker("Box creato"),
    errorMessage: marker("Impossibile creare il box")
  })
  createBox(
    tenant: string,
    payload: {
      username: string;
      name: string;
    }
  ): Observable<any> {
    return this.http.post<any>(
      `${environment.snoots.vilma.host}/api/tenants/${tenant}/boxes`,
      payload
    );
  }

  load(id: string): Observable<any> {
    return this.http.get<any>(
      `${environment.snoots.vilma.host}/api/tenants/${id}`,
      {
        headers: {
          "snt-no-cache": "true"
        }
      }
    );
  }

  searchMembers(tenantId: string, request: PageRequest): Observable<any> {
    return this.http.get<any>(
      `${environment.snoots.vilma.host}/api/tenants/${tenantId}/members`,
      {
        params: pickBy({
          p: request.page,
          s: request.pageSize
        }),
        headers: {
          "snt-no-cache": "true"
        }
      }
    );
  }

  searchBoxes(tenantId: string, request: PageRequest): Observable<any> {
    return this.http.get<any>(
      `${environment.snoots.vilma.host}/api/tenants/${tenantId}/boxes`,
      {
        params: pickBy({
          p: request.page,
          s: request.pageSize
        }),
        headers: {
          "snt-no-cache": "true"
        }
      }
    );
  }
}
